module.exports = __webpack_public_path__ + "img/GN.2cb673f7.svg";